import { SafePromise } from '@benzinga/safe-await';

import { IncludeHeader, RestfulClient } from '@benzinga/session';
import { ContentTypesForPro } from '../ingress';
import { Session } from '@benzinga/session';
import { AdvancedNewsEnvironment } from '../environment';

export class AdvancedNewsFiltersRestful extends RestfulClient {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    super(session.getEnvironment(AdvancedNewsEnvironment).url, session, includeHeaders);
  }

  public getContentTypes = (): SafePromise<ContentTypesForPro> => {
    const url = this.URL('ajax-cache/content-types-for-pro');
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
